import { render, staticRenderFns } from "./partners-list.vue?vue&type=template&id=67061616&"
import script from "./partners-list.vue?vue&type=script&lang=js&"
export * from "./partners-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports